import { hr } from 'date-fns/locale';
import ProfileLinkWithMenu from '../Shared/ProfileLinkWithMenu';
import { SUPPORTED_DOMAINS_NAMES, HOSTNAME } from '@/configs/dybr';
import {
  getRelativeUrl,
  replaceDiaryHostname,
  replaceDybrHostname
} from '@/utils/helpers/hostNames';

function SimpleLink(className, href, rel, target, children) {
  return (
    <a className={className} href={href} rel={rel} target={target}>
      {children}
    </a>
  );
}

export function Link({ href, rel, className, children, target, ...other }) {
  const dataReplyLink = other['data-reply-link'];
  if (rel === 'author' && !dataReplyLink && href) {
    const profileLinkRegex = /^\/profile\/(?<profileId>\d+)$/g;
    const matches = profileLinkRegex.exec(href);
    if (matches && matches[1]) {
      const profileId = matches[1];
      return ProfileLinkWithMenu({
        profileId,
        profileName: children,
        replyLink: dataReplyLink
      });
    }
  }

  let processedHref = dataReplyLink ?? href;
  processedHref = replaceDybrHostname(processedHref);
  processedHref = replaceDiaryHostname(processedHref);

  return SimpleLink(
    className,
    dataReplyLink ?? processedHref,
    rel,
    target,
    children
  );
}
